import React from "react";
import { Routes, Route } from "react-router-dom";
import ListReviewRating from "../Components/Rating Review Panel/listRatingReviewPanel";

const RatingReviewPanelSection = () => {
  return (
    <Routes>
      <Route path="/rating_review_panel" element={<ListReviewRating></ListReviewRating>}></Route>
    </Routes>
  );
};

export default RatingReviewPanelSection;
